import { createRequest } from "helpers/tools";

export const getTiktokAuthUrl = async () => {
    return await createRequest({
        suffix: `lead/tiktok/auth-url`,
        method: "get",
        handleError: false,
    });
};

export const tiktokAuthorize = async (data) => {
    return await createRequest({
        suffix: `lead/tiktok/authorize`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getTiktokPages = async (state, advertiser) => {
    return await createRequest({
        suffix: `lead/tiktok/pages?state=${state}&advertiser=${advertiser}`,
        method: "get",
        handleError: false,
    });
};

export const reloadTiktokPages = async (sourceAccountId) => {
    return await createRequest({
        suffix: "lead/tiktok/reload-pages",
        method: "get",
        params: { source_account_id: sourceAccountId },
        handleError: false,
    });
};

export const tiktokStore = async (data) => {
    return await createRequest({
        suffix: `lead/tiktok`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
